import {authServerInstance, gatewayInstance} from "../axiosInstance";
import { SERVICE_ENDPOINT } from "../const";

export const addCustomerShipper = async (data) => {
  const response = await gatewayInstance.post(
    `${SERVICE_ENDPOINT.TRANSPORT}/customerShipper`,
    data,
  );
  return response;
};

export const updateCustomerShipper = async (data) => {
  const response = await gatewayInstance.put(
    `${SERVICE_ENDPOINT.TRANSPORT}/customerShipper`,
    data,
  );
  return response;
};

export const searchCustomerShipper = async (data) => {
  try {
    const response = await gatewayInstance.post(
      `${SERVICE_ENDPOINT.TRANSPORT}/customerShipper/search`,
      data,
    );
    return response.data;
  } catch (e) {
    console.error(e);
  }
};

export const getCustomerShipperByCustomerId = async (cusId) => {
  try {
    console.log(`getUserCustomerByUserId data`);
    console.log(cusId);
    const response = await gatewayInstance.get(
      `${SERVICE_ENDPOINT.TRANSPORT}/customerShipper/${cusId}`,
    );
    return response.data;
  } catch (e) {
    console.error(e);
  }
};

export const findCustomerShipperByCustomerAndShipper = async (data) => {
  try {
    const response = await gatewayInstance.post(
        `${SERVICE_ENDPOINT.TRANSPORT}/customerShipper/active-shippers`,
        data,
    );
    return response.data;
  } catch (e) {
    console.error(e);
  }
};

